export const capitalizeFirstLetter = (srt: string) => {
    return srt.charAt(0).toUpperCase() + srt.slice(1);
};

export const capitalizeWords = (srt: string) => {
    return srt.replace(/(?:^|\s)\S/g, (a) => {
        return a.toUpperCase();
    });
};
